var map = {
	"./alfa-card.svg": 6428,
	"./corona-card.svg": 2276,
	"./default-card.svg": 1683,
	"./gasprom-card.svg": 6429,
	"./home-card.svg": 3255,
	"./mts-card.svg": 1492,
	"./otkr-card.svg": 8498,
	"./otp-card.svg": 7223,
	"./ozon-card.svg": 7660,
	"./pochta-bank.svg": 3033,
	"./psb-card.svg": 595,
	"./raif-card.svg": 1810,
	"./sber-card.svg": 386,
	"./t-card.svg": 5094,
	"./tochka-card.svg": 1125,
	"./ubrir-card.svg": 7022,
	"./uralsib-card.svg": 4514,
	"./vtb-card.svg": 6698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3697;